import React, { useEffect, useMemo, useState } from "react";
import styles from '../styles/announcementList.module.scss'
import { useMessageContext } from "../context";
import { useQueryNoticeListByPage } from "../hooks/useMessageCenter";
import Icon from "@/wmCompoments/Icon";
import PaginationTo from "@/views/betOrderRecords/compoments/paginationTo";
import LoadingUI from "@/compoments/loadingUI";

const AnnouncementList =() => {
  // 获取当前上下文中的通用数据和方法
  const { selectedItem, setCurrentMessage, setShowPanel } = useMessageContext();
  // 页数状态管理
  const [pageNum, setPageNum] = useState(1);
  const pageSize = 10;
  // 请求参数
  const params = useMemo(() => {
    return { category: '1,2', pageNum, pageSize } 
  }, [selectedItem, pageNum]);
  // 请求返回公告列表数据
  const { list, total, isLoading } = useQueryNoticeListByPage(params)
  // 当 selectedItem 改变时，重置页码为第一页
  useEffect(() => {
    setPageNum(1);
  }, [selectedItem]);

  return (
    <div className={styles.announcementList}>
      <LoadingUI loading={isLoading} data={list} >
        {list?.map((v,index)=>{
          return (
          <div className={styles.item} key={index} 
            onClick={()=>{
              setCurrentMessage(v);
              setShowPanel(true);
            }}
          >
            <div className={styles.icon}>
              <Icon name="icon-message-notice" />
            </div>

            <div className={styles.text}>
              <div className={styles.title}>{v.title}</div>
              <div className={styles.content}>{v.content}</div>
            </div>

            <div className={styles.time}>{v?.updatedAt}</div>
          </div>
        )})}
      </LoadingUI>

      {/* 分页器 */}
      {total >0 && <div className={styles.paginationTo}>
        <PaginationTo 
          current={pageNum}
          total={total}
          pageSize={pageSize}
          onChange={(page) => setPageNum(page)}
        />
      </div>}
    </div>
  )
}

export default  AnnouncementList